import styled, { css } from "styled-components";

interface IContainer {
  isboxwrapper?: boolean;
}

export const Container = styled.div<IContainer>`
  ${({ isboxwrapper }) => isboxwrapper && css`
    margin: 20px 10px 0 20px;
  `}
`;

interface IBoxContainer {
  height?: string;
  width?: string;
  minMax?: boolean;
}

export const BoxContainer = styled.div<IBoxContainer>`
  display: flex;
  flex-direction: column;

  padding: 25px;

  width: ${({ width }) => width || '244px'};
  height: ${({ height }) => height || '282px'};
  
  ${({ minMax, height, width }) => minMax && css`
    min-width: ${width || '244px'};
    max-width: ${width || '244px'};
    min-height: ${height || '282px'};
    max-height: ${height || '282px'};
  `}

  background: ${({ theme }) => theme.colors.surface.surface};
  border: solid 1px ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  overflow: hidden;
`;
